import DownloadTdgDocumentRequestModelBase from '../_generated/modelBases/download-tdg-document-request-model-base';

export default class DownloadTdgDocumentRequestModel extends DownloadTdgDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
